import { Component } from '@angular/core';

@Component({
  selector: 'app-noonboarded',
  templateUrl: './noonboarded.component.html',
})
export class NoonboardedComponent {}
